import React from 'react';

interface AutocompleteFormatLKZProps {
  suchvorschlag?: any;
}

export const AutocompleteFormatOrtsname = ({
  suchvorschlag,
}: AutocompleteFormatLKZProps) => {
  return (
    suchvorschlag && (
      <span>{`${suchvorschlag['ortsname']} - ${suchvorschlag['plz']}`}</span>
    )
  );
};
